
































































































import { Trans } from "../../scripts/helpers/translation/translation";
import Vue from "vue";
import { Classified } from "@/shared/interfaces/classified/Classified.interface";

export default Vue.extend({

    props: {
        cardSize: {
            type: String,
            required: true
        },
        classified: {
            type: Object,
            required: false,
            default: null
        }
    },

    data: function() {
        return {
            isMobile: true,
            classifiedData: {} as Classified
        };
    },

    computed: {
        classifiedTitle: function(): string|null {
            if(this.classifiedData.property.title && this.classifiedData.property.title[Trans.currentLocale]) {
                return this.classifiedData.property.title[Trans.currentLocale];
            } else {
                return this.$t(this.classifiedData.property.type.toLowerCase()) as string;
            }
        },
        price: function(): string|number|undefined {
            let price;
            if(this.classifiedData.transaction.type === "FOR_SALE") {
                price = this.classifiedData.transaction.sale.price;
            }
            if(this.classifiedData.transaction.type === "FOR_RENT") {
                price = this.classifiedData.transaction.rental.monthlyRentalPrice;
            }
            return price;
        },
        netHabitableSurface: function(): string|number|undefined {
            let netHabitableSurface;
            if(this.classifiedData.property.livingDescription) {
                netHabitableSurface = this.classifiedData.property.livingDescription.netHabitableSurface;
            }
            return netHabitableSurface;
        },
        bedroomCount: function(): string|number|null|undefined {
            let bedroomCount;
            if(this.classifiedData.property.bedroom) {
                bedroomCount = this.classifiedData.property.bedroom.count;
            }
            return bedroomCount;
        },
        classifiedDescription: function(): string {
            let description = "" as string;
            if(this.classifiedData.property.description[Trans.currentLocale]) {
                description = this.classifiedData.property.description[Trans.currentLocale] as string;
            }
            if(description.length > 60) {
                return description.substr(0,60) + " ...";
            } else {
                return description;
            }
        },
        locality: function(): string|number|null|undefined {
            return this.classifiedData.property.location.address.locality;
        },
        postalCode: function(): string|number|null|undefined {
            return this.classifiedData.property.location.address.postalCode;
        },
        pictures: function(): Array<{ url: string }> | null {
            if(this.classifiedData.pictures) {
                // Upgrade Visibility package
                return this.classifiedData.pictures;
            } else {
                return this.$store.getters["PicturesModule/getPictures"];
            }
        }
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-medium", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    created: function() {
        if(this.classified) {
            // Upgrade Visibility package
            this.classifiedData = this.classified;
        } else {
            this.classifiedData = this.$store.getters["FormModule/getCriteria"];
        }
    }
});
